import { CoolingUpdateLayout } from './CoolingUpdate.layout';
import { CoolingDeficiencyLayout } from './CoolingDeficiency.layout';

export class CoolingSystemLayout {
	public fields = [
		{ fieldName: 'uniformCoolingIndicator', label: 'Indicator' },
		{ fieldName: 'coolingType', label: 'Type' },
		{ fieldName: 'cv_coolingIndividual', label: 'Timeframe' }
	];

	public fieldsArray = [
		{
			fieldName: 'coolingUpdates',
			label: 'Cooling Updates',
			fields: new CoolingUpdateLayout().fields
		},
		{
			fieldName: 'coolingDeficiencies',
			label: 'Cooling Deficiencies',
			fields: new CoolingDeficiencyLayout().fields
		}
	];
}
